module.exports = __webpack_public_path__ + "img/gear.c7ea9839.png";